/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_RefreshingInputs */

const en_settings_refreshing = /** @type {(inputs: Settings_RefreshingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refreshing…`)
};

const he_settings_refreshing = /** @type {(inputs: Settings_RefreshingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מרענן…`)
};

/**
* | output |
* | --- |
* | "Refreshing…" |
*
* @param {Settings_RefreshingInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const settings_refreshing = /** @type {((inputs?: Settings_RefreshingInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_RefreshingInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_refreshing(inputs)
	return he_settings_refreshing(inputs)
});